import React, { useRef } from "react";
import { clamp01, round } from "./frameGeometry";
import "./FrameAnnotations.css";

const MIN_STEP = 0.002; // не писать точки ближе 0.2% кадра — экономит место

/**
 * Прозрачный слой над кадром, который ловит указатель и дописывает штрихи в drawing.
 * Координаты — доли кадра (0..1). Работает мышью, пальцем и стилусом (pointer events).
 */
const DrawingCanvas = ({ frameRect, drawing, onChange, color, strokeWidth }) => {
  const activeStroke = useRef(null);
  const baseStrokes = useRef([]); // штрихи, которые были до начала текущего
  const layerRef = useRef(null);

  if (!frameRect || !frameRect.width || !frameRect.height) return null;

  const toFraction = (e) => {
    const r = layerRef.current.getBoundingClientRect();
    return [
      round(clamp01((e.clientX - r.left) / r.width), 4),
      round(clamp01((e.clientY - r.top) / r.height), 4),
    ];
  };

  const emit = (stroke) => {
    onChange({ v: 1, strokes: [...baseStrokes.current, { ...stroke, p: stroke.p.slice() }] });
  };

  const handleDown = (e) => {
    if (e.button !== undefined && e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    layerRef.current.setPointerCapture?.(e.pointerId);
    baseStrokes.current = (drawing && drawing.strokes) || [];
    activeStroke.current = { c: color, w: strokeWidth, p: [toFraction(e)] };
    emit(activeStroke.current);
  };

  const handleMove = (e) => {
    const s = activeStroke.current;
    if (!s) return;
    e.preventDefault();
    const pt = toFraction(e);
    const last = s.p[s.p.length - 1];
    if (Math.abs(pt[0] - last[0]) < MIN_STEP && Math.abs(pt[1] - last[1]) < MIN_STEP) return;
    s.p.push(pt);
    emit(s);
  };

  const handleUp = (e) => {
    if (!activeStroke.current) return;
    e.preventDefault();
    layerRef.current.releasePointerCapture?.(e.pointerId);
    activeStroke.current = null;
  };

  return (
    <div
      ref={layerRef}
      className="fa-draw-layer"
      style={{
        left: frameRect.left,
        top: frameRect.top,
        width: frameRect.width,
        height: frameRect.height,
      }}
      onPointerDown={handleDown}
      onPointerMove={handleMove}
      onPointerUp={handleUp}
      onPointerCancel={handleUp}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default DrawingCanvas;
